import { useContext } from "react";
import { Button } from "iuvity-ui-components";
import { NewDialogProps } from "../dialog/NewCustomDialog";
import { CreateLabelsForm } from "../translation/CreateLabelsForm";
import { AppContext } from "../../context";
interface CreateLabelsButtonProps {
    setModalProps: React.Dispatch<React.SetStateAction<NewDialogProps>>;
    dialogTitle: string;
    dialogDetail: string;
    buttonLabel: string;
    functionality: string;
    actionsToExecute?: Function;
    isAdminFunctionality?: boolean;
    customFunctionalitiesList?: {}[];
}
export const CreateLabelsButton: React.FC<CreateLabelsButtonProps> = ({
    setModalProps,
    dialogTitle='',
    dialogDetail='',
    buttonLabel='',
    functionality='Translations',
    actionsToExecute=()=>{},
    isAdminFunctionality,
    customFunctionalitiesList,
}) => {
    const { t } = useContext(AppContext);

    return (
        <div>
            <Button
                variant="p-button-link"
                label={buttonLabel}
                icon="iu iu-icon-plus"
                onClick={()=>{
                    setModalProps((prev: any) => ({
                    ...prev,
                    visible: true,
                    title: () => (
                        <div>
                        <div>
                            <div className="mb-4">
                                {dialogTitle}
                            </div>
                            <div style={{
                            fontFamily : "var(--fontBarlowMedium)",
                            fontSize: "var(--font-size-md)",
                            color: "var(--cardBackgroundColorOneShade80)",
                            lineHeight: "1.5",
                            }}>
                             {dialogDetail}
                            </div>
                        </div>
                        </div>
                    ),
                    content: (
                        <CreateLabelsForm
                            functionality={functionality}
                            actionsToExecute={actionsToExecute}
                            isAdminFunctionality={!!isAdminFunctionality}
                            customFunctionalitiesList={customFunctionalitiesList}
                        />
                    ),
                    acceptLabel: t("Translations.createBtnLabel"),
                    rejectLabel: t("Translations.cancelBtnLabel"),
                    onReject: () => {
                        setModalProps({
                            visible: false,
                            onReject: undefined,
                            acceptLabel: undefined,
                            rejectLabel: undefined,
                          });
                    }
                    }));
                }}
            />
        </div>
    )
}
